// Route prefetch map — mirrors the lazy() imports in App.tsx
export const routePrefetchMap: Record<string, () => Promise<any>> = {
  '/a-nucleo': () => import('../pages/ANucleo'),
  '/blog': () => import('../pages/Blog'),
  '/cit': () => import('../pages/CIT'),
  '/academy': () => import('../pages/Academy'),
  '/faca-parte': () => import('../pages/FacaParte'),
  '/intranet': () => import('../pages/Intranet'),
  '/solucoes/reducao-tributaria': () => import('../pages/solucoes/ReducaoTributaria'),
  '/solucoes/assessoria-contabil': () => import('../pages/solucoes/AssessoriaContabil'),
  '/solucoes/consultoria-contabil': () => import('../pages/solucoes/ConsultoriaContabil'),
  '/solucoes/bpo-financeiro': () => import('../pages/solucoes/BPOFinanceiro'),
  '/solucoes/assessoria-bdmg': () => import('../pages/solucoes/AssessoriaBDMG'),
  '/solucoes/certificado-digital': () => import('../pages/solucoes/CertificadoDigital'),
  '/solucoes/contpay': () => import('../pages/solucoes/ContPay'),
  '/solucoes/energia': () => import('../pages/solucoes/Energia'),
};

const prefetched = new Set<string>();

export function prefetchRoute(path: string) {
  if (prefetched.has(path)) return;
  const loader = routePrefetchMap[path];
  if (loader) {
    prefetched.add(path);
    loader();
  }
}

/** Prefetch high-priority routes after idle */
export function prefetchIdleRoutes() {
  const priorities = [
    '/a-nucleo', '/blog', '/cit', '/academy', '/faca-parte',
    '/solucoes/reducao-tributaria', '/solucoes/assessoria-contabil',
    '/solucoes/consultoria-contabil', '/solucoes/bpo-financeiro',
    '/solucoes/assessoria-bdmg', '/solucoes/certificado-digital',
    '/solucoes/contpay', '/solucoes/energia',
  ];
  const run = () => priorities.forEach(prefetchRoute);
  if ('requestIdleCallback' in window) {
    requestIdleCallback(run, { timeout: 5000 });
  } else {
    setTimeout(run, 3000);
  }
}
